/**
 * Nama topic Broadcast — SATU-SATUNYA sumber kebenarannya di sisi TypeScript.
 *
 * Pasangannya ada di `supabase/migrations/4440_realtime_broadcast.sql` (enam
 * topic pertama) dan `8110_stasiun_cetak.sql` (`store-print`): trigger di sana
 * menyusun string yang sama persis, dan policy `select` di `realtime.messages`
 * mem-parse-nya kembali lewat `public.topic_uuid()`. Ketiga tempat itu harus
 * sepakat huruf demi huruf — salah satu meleset berarti klien subscribe ke
 * topic yang tak pernah menerima apa pun, TANPA error.
 *
 * ── KENAPA PREFIX-NYA TIDAK BOLEH SALING MENJADI AWALAN ─────────────────────
 * `customer` dan `customer-activity` adalah jebakan yang nyata: policy di SQL
 * mencocokkan `'^' || prefix || ':<uuid>$'`, jadi pemisah `:` yang membuat
 * `customer` TIDAK ikut mencocoki `customer-activity:<uuid>`. Kalau suatu saat
 * ada prefix baru yang memuat `:`, atau dua prefix yang salah satunya awalan
 * yang lain PLUS `:`, gerbangnya jebol. `realtimeTopics.test.ts` menjaga itu.
 */

/** Prefix topic. Nilainya terikat kontrak dengan mig 4440/8110 — jangan diubah
 *  tanpa migrasi baru yang mengubah trigger DAN policy-nya sekaligus. */
export const TOPIC_PREFIX = {
  /** Notifikasi pembeli — dikunci ke `customers.id`. */
  notif: "notif",
  /** Order + nota milik pembeli — dikunci ke `customers.id`. */
  customerActivity: "customer-activity",
  /** Perubahan profil pembeli — dikunci ke `customers.id`. */
  customer: "customer",
  /** Lonceng admin — dikunci ke `auth.uid()` admin (fan-out per admin, mig 0780). */
  adminNotif: "admin-notif",
  /** Badge nota se-toko — dikunci ke `stores.id`. */
  storeInvoices: "store-invoices",
  /** Pengiriman reseller — dikunci ke `auth.uid()`, BUKAN `customers.id`
   *  (`shipment_requests.reseller_id` memang menyimpan auth uid). */
  resellerShipments: "reseller-shipments",
  /** Antrean Stasiun Cetak se-toko — dikunci ke `stores.id` (mig 8110). */
  storePrint: "store-print",
} as const;

export type TopicPrefix = (typeof TOPIC_PREFIX)[keyof typeof TOPIC_PREFIX];

function topic(prefix: TopicPrefix, id: string): string {
  return `${prefix}:${id}`;
}

export function notifTopic(customerId: string): string {
  return topic(TOPIC_PREFIX.notif, customerId);
}

export function customerActivityTopic(customerId: string): string {
  return topic(TOPIC_PREFIX.customerActivity, customerId);
}

export function customerTopic(customerId: string): string {
  return topic(TOPIC_PREFIX.customer, customerId);
}

export function adminNotifTopic(adminAuthUid: string): string {
  return topic(TOPIC_PREFIX.adminNotif, adminAuthUid);
}

export function storeInvoicesTopic(storeId: string): string {
  return topic(TOPIC_PREFIX.storeInvoices, storeId);
}

export function resellerShipmentsTopic(resellerAuthUid: string): string {
  return topic(TOPIC_PREFIX.resellerShipments, resellerAuthUid);
}

export function storePrintTopic(storeId: string): string {
  return topic(TOPIC_PREFIX.storePrint, storeId);
}
